// src/pages/CreateGamePage.js
import React from 'react';
import CreateGameForm from '../../components/dashboard/CreateGameForm';
import { useNavigate } from 'react-router-dom';

const CreateGamePage = () => {
  const navigate = useNavigate();

  const handleCreateSuccess = () => {
    navigate('/dashboard'); // Redirect to dashboard - change to /games when created
  };

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto', padding: '20px' }}>
      <CreateGameForm onCreateSuccess={handleCreateSuccess} />
    </div>
  );
};

export default CreateGamePage;
